export const selectPuntosAcupuntura = (state) => state.holonmed.puntos;
